export var OiamEvents;
(function (OiamEvents) {
    OiamEvents["LOADED"] = "oiamLoadedEvent";
    OiamEvents["READYFORLOGIN"] = "oiamReadyForLoginEvent";
    OiamEvents["SETCONFIG"] = "oiamSetConfigEvent";
    OiamEvents["TOKEN"] = "oiamTokenEvent";
    OiamEvents["SENDTOKEN"] = "oiamSendTokenEvent";
    OiamEvents["DOLOGIN"] = "oiamLoginEvent";
    OiamEvents["DOLOGOUT"] = "oiamLogoutEvent";
    OiamEvents["ERROR"] = "oiamErrorEvent";
    /**
     * @deprecated replaced by IDLESESSIONEXPIRATIONWARNING
     */
    OiamEvents["IDLESESSIONEXPIREWARNING"] = "oiamIdleSessionExpireWarnEvent";
    OiamEvents["IDLESESSIONEXPIRATIONWARNING"] = "oiamIdleSessionExpirationWarnEvent";
    /**
     * @deprecated replaced by IDLESESSIONEXPIRATION
     */
    OiamEvents["IDLESESSIONEXPIRED"] = "oiamIdleSessionExpiredEvent";
    OiamEvents["IDLESESSIONEXPIRATION"] = "oiamIdleSessionExpirationEvent";
    OiamEvents["MAXSESSIONEXPIRATIONWARNING"] = "oiamMaxSessionExpirationWarnEvent";
    OiamEvents["MAXSESSIONEXPIRATION"] = "oiamMaxSessionExpirationEvent";
    OiamEvents["CUSTOMSTATE"] = "oiamCustomStateEvent";
    OiamEvents["SESSION"] = "oiamSessionEvent";
    OiamEvents["SENDSESSION"] = "oiamSendSessionEvent";
    OiamEvents["BEFORENAVIGATION"] = "oiamBeforeNavigationEvent";
})(OiamEvents || (OiamEvents = {}));
